<div class="update-app">
  <span
    >Nouvelle version de l'application disponible. Merci de recharger votre page en cliquant
    <span (click)="reload()" class="click-here"> ici</span></span
  >
</div>
